export default function buildAvailableLocationsFromUserAppointmentCalendar(userAppointmentCalendar) {
  if(!userAppointmentCalendar) return null

  return [
    userAppointmentCalendar.attributes.locationInPersonEnabled ? "In Person" : null,
    userAppointmentCalendar.attributes.locationPhoneEnabled ? "Phone" : null,
    userAppointmentCalendar.attributes.locationZoomEnabled ? "Zoom" : null,
    userAppointmentCalendar.attributes.locationOtherEnabled ? userAppointmentCalendar.attributes.locationOtherLabel : null
  ].filter(Boolean)
}
